import { render } from "./SerieDetail.vue?vue&type=template&id=c3f3a9ba&scoped=true"
import script from "./SerieDetail.vue?vue&type=script&lang=js"
export * from "./SerieDetail.vue?vue&type=script&lang=js"

import "./SerieDetail.vue?vue&type=style&index=0&id=c3f3a9ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f3a9ba"]])

export default __exports__